// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"590":"c929ff85","724":"afe6f21b"}[chunkId] + ".css";
};